export const mapSingleAnnualInvoiceToMonthly = (invoices) => {
    const result = [];
    invoices.forEach((item) => {
        var _a;
        if ((_a = item.plan) === null || _a === void 0 ? void 0 : _a.includes('annual')) {
            const startDate = new Date(item.ChargeStartDate);
            const endDate = new Date(item.ChargeStartDate);
            let monthCounter = startDate.getMonth();
            let year = startDate.getFullYear();
            for (let i = 0; i < 12; i++) {
                if (monthCounter === 0 && i > 0) {
                    startDate.setFullYear(year);
                }
                if (monthCounter === 11) {
                    startDate.setMonth(monthCounter);
                    monthCounter = 0;
                    year += 1;
                    endDate.setMonth(monthCounter);
                    endDate.setFullYear(year);
                }
                else {
                    startDate.setMonth(monthCounter);
                    endDate.setMonth(monthCounter + 1);
                    monthCounter++;
                }
                result.push(Object.assign(Object.assign({}, item), { ChargeStartDate: startDate.toISOString(), ChargeEndDate: endDate.toISOString() }));
            }
        }
        else {
            result.push(item);
        }
    });
    return result;
};
